/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { type Meta, type StoryObj } from '@storybook/react-vite';

import { Tabs } from '../../index';
import {
  TabsBadge,
  TabsBadgeSource,
  TabsDefault,
  TabsDefaultSource,
  TabsDisabled,
  TabsDisabledSource,
  TabsFillVariants,
  TabsFillVariantsSource,
  TabsOverflow,
  TabsOverflowSource,
  TabsSizes,
  TabsSizesSource,
  TabsWithIcons,
  TabsWithIconsSource,
} from '.';

const componentMeta: Meta<typeof Tabs> = {
  component: Tabs,
  decorators: [
    (Story) => (
      <div className="n-flex n-justify-center ">
        <Story />
      </div>
    ),
  ],
  id: 'components-tabs',
  parameters: {
    controls: { disable: true },
  },
  tags: ['docsPage'],
  title: 'Components/Tabs',
} satisfies Meta<typeof Tabs>;

export default componentMeta;
type Story = StoryObj<typeof componentMeta>;

export const Default: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: TabsDefaultSource,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TabsDefault,
};

export const FillVariants: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: TabsFillVariantsSource,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TabsFillVariants,
};

export const Sizes: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: TabsSizesSource,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TabsSizes,
};

export const WithIcons: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: TabsWithIconsSource,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TabsWithIcons,
};

export const Disabled: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: TabsDisabledSource,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TabsDisabled,
};

export const Overflow: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: TabsOverflowSource,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TabsOverflow,
};

export const Badge: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: TabsBadgeSource,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TabsBadge,
};
